let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("19KJH"), load("ffEVr"), load("hAerp")]).then(() => parcelRequire('kGWTg'));